/* src/app/components/doc-viewer-new/doc-viewer-context-panel/doc-navigation-list/doc-navigation-list.component.scss */
.docs {
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
  font-size: 14px;
  color: black;
  cursor: pointer;
}
.docs:hover {
  background: rgba(0, 0, 0, 0.08);
}
:host-context(.dark-theme) .docs {
  color: white;
}
:host-context(.dark-theme) .docs:hover {
  background: rgba(0, 0, 0, 0.32);
}
.active {
  border-left: 4px solid rgb(63, 81, 181);
  background: rgba(57, 73, 171, 0.08);
  padding: 10px 13px;
}
.active:hover {
  background: rgba(57, 73, 171, 0.08);
}
:host-context(.dark-theme) .active {
  border-left: 4px solid #ffc107;
  background: rgba(0, 0, 0, 0.32);
}
:host-context(.dark-theme) .divider {
  border-bottom: 1px solid rgba(58, 58, 58, 0.8196078431);
}
.divider {
  border-bottom: 1px solid #f1f1f1;
}
/*# sourceMappingURL=doc-navigation-list.component.css.map */
